/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IMediaCategoryModel, RouteHelper } from "@nf/common";
import dynamic from "next/dynamic";

import GenreCard from "./GenreCard";

import styles from "./Genres.module.scss";

const LinkWithLocale = dynamic(() => import("components/LinkWithLocale"));

interface GenresProps {
  genres: IMediaCategoryModel[];
}

const Genres = ({ genres }: GenresProps) => (
  <ul className={styles.genres}>
    {genres.map((genre) => (
      <li key={genre.CategoryId} className={styles.genre}>
        <LinkWithLocale href={RouteHelper.goToGenre(genre.CategoryId)}>
          <a>
            <GenreCard id={genre.CategoryId} name={genre.CategoryName} />
          </a>
        </LinkWithLocale>
      </li>
    ))}
  </ul>
);

export default Genres;
